<template>
    <v-container class="fill-height" style="display: block;" fluid>

        <v-form class="mt-2" ref="advancedFiltersForm" :lazy-validation="true" v-model="formValid">
            <v-simple-table class="config-table" fixed-header height="800px" style="position: relative; max-height: calc(100vh - 400px);">
                <thead>
                    <tr>
                        <th class="text-left">Enabled</th>
                        <th class="text-left">Status</th>
                        <th class="text-left">Property</th>
                        <th class="text-left">Method</th>
                        <th class="text-left">Value</th>
                        <th class="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(filter, index) in $props.filters">
                        <advanced-filter :filter="filter" :index="index" :filterValueLists="filterValueLists" :alarmGridResources="alarmGridResources" @delete="deleteFilter" />
                    </template>
                </tbody>
            </v-simple-table>

            <div style="text-align: center;">
                <v-btn class="mt-2 mr-2 d-inline-block" color="#c42111" @click="addNewFilter">New</v-btn>
                <v-btn class="mt-2 d-inline-block" color="#c42111" @click="showImportFiltersClick">Import</v-btn>
            </div>

        </v-form>

        <v-dialog v-model="showAlarmFilterViews" max-width="80%" width="800px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showAlarmFilterViews = false : null}">
            <alarm-filter-views v-if="showAlarmFilterViews" :views="$props.alarmViews" :compatibleFilters="filterProperties" @close="showAlarmFilterViews = false" @import="importFilters" />
        </v-dialog>

    </v-container>
</template>

<script>
import AlarmFilterViews from "@/components/GeoMap/AlarmFilterViews";
import AdvancedFilter from "@/components/GeoMap/AdvancedFilter";
export default {
    name: 'GeoMapAdvancedAlarmFilters',
    props: ['filters', 'filterValueLists', 'alarmGridResources', 'alarmViews'],
    components: {
        AlarmFilterViews,
        AdvancedFilter
    },
    data: () => ({
        formValid: false,
        filterProperties: [
            {text: 'Acked', value: 'alarm_acked', no_method: true, control: 'yes_no'},
            {text: 'Description', value: 'alarm_description', control: 'text'},
            //{text: 'Duplicate', value: 'alarm_is_dupe', control: 'bool_yes_no'},
            {text: 'Local Time', value: 'alarm_local_time', control: 'datetime'},
            {text: 'Locale', value: 'site_locale', control: 'multi_select'}, 
            {text: 'Severity', value: 'alarm_severity', control: 'multi_select'},
            {text: 'Service Affecting', value: 'alarm_service_affecting', no_method: true, control: 'yes_no'},
            {text: 'Time', value: 'alarm_time', control: 'datetime'}, 
        ],
        filterMethods: {
            yes_no: [
                {text: 'Yes', value: 'yes'},
                {text: 'No', value: 'no'}
            ],
            bool_yes_no: [
                {text: 'Yes', value: 'yes'},
                {text: 'No', value: 'no'}
            ],
            text: [
               {text: 'Contains', value: 'contains'},
               {text: 'Not Contains', value: 'notContains'},
               {text: 'Equals', value: 'equals'},
               {text: 'Not Equals', value: 'notEquals'},
               {text: 'Starts With', value: 'startsWith'},
               {text: 'Ends With', value: 'endsWith'}
            ],
            multi_select: [
               {text: 'Contains', value: 'contains'},
               //{text: 'Not Contains', value: 'not_contains'}
            ],
            datetime: [
                {text: 'Before', value: 'lessThan'},
                {text: 'After', value: 'greaterThan'},
                {text: 'Range', value: 'inRange'},
            ]
        },

        yes_no_values: [
            {text: 'Yes', value: true},
            {text: 'No', value: false},
        ],

        showAlarmFilterViews: false,
    }),

    computed: {

    },

    methods: {
        addNewFilter: function() {
            this.filters.push({
                enabled: true,
                property: '',
                method: '',
                value: '',
                valid: false,
                status: [],
            });
            this.validateForm();
        },

        validateForm: function() {
            this.$nextTick(() => {
                this.$refs.advancedFiltersForm.validate();
                console.log('validating whole form: ', this.$refs.advancedFiltersForm.validate());
            });
        },

        showImportFiltersClick: function() {
            this.showAlarmFilterViews = true;
        },

        importFilters: function(viewFilters) {
            console.log('Import/apply view filters: ', viewFilters);
            console.log(Object.keys(viewFilters));
            for(let viewFilterKey of Object.keys(viewFilters)) {
                let viewFilterObj = viewFilters[viewFilterKey];
                console.log('viewFilterObj: ', viewFilterObj);
                let filterProperty = this.filterProperties.find(fp => fp.value == viewFilterKey) || '';
                let filterMethod = this.filterMethods[filterProperty.control] && this.filterMethods[filterProperty.control].length == 1 ? this.filterMethods[filterProperty.control][0].value : '';  // Only works for multi-select control (contains)
                let filterValue = viewFilterObj.values; // Works for multiselect

                if(filterProperty.control == 'datetime') {
                    filterMethod = viewFilterObj.type;
                    filterValue = {dateFrom: viewFilterObj.dateFrom, dateTo: viewFilterObj.dateTo};
                    
                }
                else if(filterProperty.control == 'text') {
                    filterMethod = viewFilterObj.type;
                    filterValue = viewFilterObj.filter;
                }
                else if(filterProperty.control == 'yes_no') {
                    filterValue = viewFilterObj.values.length == 1 ? !!viewFilterObj.values[0] : null;
                }
                else if(filterProperty.control == 'multi_select') {
                    filterMethod = this.filterMethods.multi_select[0];
                    filterValue = viewFilterObj.values;
                    console.log('multi_select values are: ', filterValue);
                    if(viewFilterObj.values.includes(null)) {
                        filterValue.push('blanks');
                    }
                    filterValue = filterValue.filter(v => v !== null);
                }

                this.filters.push({
                    enabled: true,
                    property: filterProperty,
                    method: filterMethod,
                    value: filterValue,
                    valid: false,
                    status: []
                });
            }

            this.validateForm();
        },

        deleteFilter: function(filterIndex) {
            this.$props.filters.splice(filterIndex, 1);
        },
    },

    watch: {
    },

    created() {
        // console.log('advanced filters created');
        // // Format the datetime filter values to work with the datetime pickers
        // for(let filter of this.$props.filters) {
        //     if(filter.property.control == 'datetime') {
        //         if(filter.value.dateFrom) {
        //             console.log(filter.value.dateFrom);
        //             filter.value.dateFrom = TELSA.moment(filter.value.dateFrom).isValid() ? TELSA.moment(filter.value.dateFrom).format('YYYY-MM-DD HH:mm:ss') : null;
        //         }
        //         if(filter.value.dateTo) {
        //             console.log(filter.value.dateTo);
        //             filter.value.dateTo = TELSA.moment(filter.value.dateTo).isValid() ? TELSA.moment(filter.value.dateTo).format('YYYY-MM-DD HH:mm:ss') : null;
        //         }
        //     }
        // }
    },

    mounted() {
        
    }

  
};
</script>

<style scoped>

    .config-table {
        border-radius: 3px;
        /* border: rgba(255, 255, 255, 0.24) solid 1px; */
        overflow-y: auto;
        background-color: #303030 !important;

        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    }
    .config-table thead tr th {
        background-color: #303030 !important;
    }

</style>
